import { ArrowRightAddDualSelector as Add, ArrowRightAddAllDualSelector as AddAll, ArrowLeftRemoveDualSelector as Remove, ArrowLeftRemoveAllDualSelector as RemoveAll, Undo } from '@sas/react-svg';
import cx from 'classnames';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { Button, ButtonVariant } from '../../Button';
import bundle from '../NovaComponents-DualSelector-gui-icu.properties';
import './MoveButton.css';
import cn from './MoveButton.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const MoveButton = props => {
  const dt = useDesignTokens();
  const moveButtonTokens = renderInlineCssVars({
    spacing: dt.tokens['space-base-null']
  }, 'move-button');
  const localize = useTextLocalizer();
  let selectActionText, selectionIcon;
  const icon = {
    add: Add,
    addAll: AddAll,
    undo: Undo,
    remove: Remove,
    removeAll: RemoveAll,
    custom_add: Add
  };
  const {
    direction,
    isMoveAll
  } = props;
  let testIdText;

  /* -------------------------------------------
   * Icon & text selection for tooltip
   * ---------------------------------------------*/
  if (props.isMoveAll) {
    const newDirection = `${props.direction}All`;
    selectionIcon = icon[newDirection];
    selectActionText = localize(`moveButton.${newDirection.toLocaleLowerCase()}.button.tooltip.label`);
    testIdText = `${props.direction}All`;
  } else {
    selectionIcon = icon[props.direction];
    selectActionText = localize(`moveButton.${props.direction}.button.tooltip.label`);
    if (props.direction === 'custom_add' && props.customAddButtonTooltip) {
      selectActionText = props.customAddButtonTooltip;
    }
    testIdText = props.direction;
  }
  const classes = props.direction === 'custom_add' ? cx(cn.moveButtons, cn.customButton) : cn.moveButtons;
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    style: moveButtonTokens,
    children: /*#__PURE__*/_jsx(Button, {
      testId: postfixTestId(props.testId, testIdText),
      variant: ButtonVariant.Icon,
      icon: {
        icon: selectionIcon,
        tooltip: selectActionText
      },
      onPress: () => props.onPress(direction, isMoveAll, props.layoutIndex),
      disabled: props.disabled,
      ariaLabel: props.ariaLabel
    })
  });
};
//# sourceMappingURL=MoveButton.js.map